import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import './MedicationForms.css';
import { fetchUserProfile, saveMedicationMetaDoc, fetchFormDataMedication } from '../services/Service';
import axios from "axios";
import Select from 'react-select';
import MedicationsList from '../assessment/MedicationsList';
import { FaBullseye } from 'react-icons/fa6';


const MedicationFormsMetaDoc = ({ closeModal, selectedServiceRecord, callHomeBasedServicesHistory, membershipNoMember, aiBupaServiceRecommendations, getAiBupaServiceRecommendations }) => {

    const qsParams = useParams();
    const userId = qsParams.memberId;

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [disabledButton, setDisabledButton] = useState(true);
    const [showRemove, setShowRemove] = useState(false);
    const [cityList, setCityList] = useState([]);
    const [frequencyList, setFrequencyList] = useState([]);
    const [partnerList, setPartnerList] = useState([]);
    const [pharmacyList, setPharmacyList] = useState([]);

    const medicationsObj = {
        productId: '',
        productName: '',
        quantity: '',
        comments: '',
        frequency: '',
        duration: '',
        supplyFrom: '',
        supplyTo: '',
        sfdaCode: '',
        source:'',
        recommendationId: ''
    }

    let aiBupaMedicines = [];


    if (aiBupaServiceRecommendations[0]?.medicines?.length > 0) {
        aiBupaMedicines = aiBupaServiceRecommendations[0]?.medicines?.map((item) => ({
            productId: item.medicineId || '',
            productName: item.serviceDesc || '',
            quantity: item.servicelineItemQuantity || '',
            comments: '',
            frequency: '',
            supplyFrom: '',
            supplyTo: '',
            duration: '',
            sfdaCode:'',
            source: 'aibupa',
            recommendationId: item.recommendationId
        }));
    }
    const [formData, setFormData] = useState({
        userId: userId,
        selectedServiceRecord: selectedServiceRecord,
        membership: '',
        name: '',
        mobileNumber: '',
        partnerClinic: '',
        remarks: '',
        nationality: '',
        pharmacy: '',
        labProviderName: '',
        deliveryRefill: '',
        orderType: '',
        city: '',
        district: '',
        deductible: '',
        medications: (aiBupaServiceRecommendations[0]?.medicines?.length > 0) ? aiBupaMedicines : [medicationsObj],
        cityId: ''
    });

    const [addMedicationsComponentCount, setAddMedicationsComponentCount] = useState(formData.medications.length);



    useEffect(() => {
        fetchUserData();
        dropdownData();
        
        if (aiBupaServiceRecommendations[0]?.medicines?.length > 1) {
            setShowRemove(true);
        }
    }, [])


    const fetchUserData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        setDisabledButton(true);
        await fetchUserProfile(userId, 'metaService')
            .then((response) => {
                if (response.data.code === 200) {
                    setFormData((prev) => ({ ...prev, membership: response.data.data.info.membershipNumber, name: response.data.data.info.memberName, mobileNumber: response.data.data.info.mobile, nationality: response.data.data.info.nationality }));
                    setDisabledButton(false);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }


    const handleChange = async (e) => {
        const { name, value } = e.target;

        const updatedFormData = { ...formData, [name]: value };

        if (name === "pharmacy") {
            updatedFormData.labProviderName = e.target.selectedOptions[0].text;
        }

        if(name === "mobileNumber"){
            // Ensure first character is always 0 and total length <= 11
            if (!value.startsWith('0')) {
                // Add 0 prefix but limit total length to 11
                updatedFormData.mobileNumber = ('0' + value).slice(0, 11);
            } else if (value.length === 1 && value === '0') {
                // Keep the 0 if it's being deleted
                updatedFormData.mobileNumber = '0';
            } else {
                // Limit length to 11 digits
                updatedFormData.mobileNumber = value.slice(0, 11);
            }
        }

        setFormData(updatedFormData);

        setError('');
    };

    const validateForm = () => {
        const mandatoryFields = ['membership', 'name', 'mobileNumber', 'partnerClinic', 'deliveryRefill', 'orderType', 'city', 'nationality'];

        for (let field of mandatoryFields) {
            if ((field === 'city')) {
                if (formData[field] == "") {
                    setError('Enter all mandatory fields');
                    return false;
                }
            } else if (!formData[field].trim()) {
                setError('Enter all mandatory fields');
                return false;
            }


        }

        return true;
    };

    const handleChangeCity = (selectedOption) => {
        fetchCategoryList(selectedOption.value);
        setFormData({
            ...formData,
            ['city']: selectedOption.label,
            ['cityId']: selectedOption.value,
        });
    };

    const fetchCategoryList = async (cityName) => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchFormDataMedication(cityName, formData['membership'])
            .then((response) => {
                if (response.data.code === 200) {
                    setPharmacyList(response.data.data.pharmacy);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const handleSubmit = async (event) => {
        setError('');
        event.preventDefault();
        if (validateForm()) {
            const request = axios.CancelToken.source();
            let ct = {
                cancelToken: request.token
            }
            setDisabledButton(true);
            await saveMedicationMetaDoc(formData)
                .then((response) => {
                    if (response.data.code === 200) {

                        getAiBupaServiceRecommendations(membershipNoMember);
                        setMessage(response.data.data.message);
                        callHomeBasedServicesHistory();
                        setTimeout(() => {
                            closeModal();
                        }, 1000);
                    } else {
                        setMessage('');
                        setError(response.data.data.message);
                        setDisabledButton(false);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            return () => request.cancel();
        }
    }


    const dropdownData = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchFormDataMedication()
            .then((response) => {
                if (response.data.code === 200) {
                    setCityList(response.data.data.city);
                    setPharmacyList(response.data.data.pharmacy);
                    setPartnerList(response.data.data.partner);
                    setFrequencyList(response.data.data.frequency);
                } else {
                    setError(response.data.data.message);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }


    const addComponent = () => {
        setAddMedicationsComponentCount(addMedicationsComponentCount + 1);
        if (addMedicationsComponentCount > 0) {
            setShowRemove(true);
        }
        setFormData({
            ...formData,
            medications: [...formData.medications, medicationsObj]
        });
        
    };


    const handleFieldChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...formData.medications];
        list[index][name] = value;
        if (name == "productId") {
            list[index]["code"] = ''
            list[index]["productName"] = ''
        }
       
        setFormData({ ...formData, medications: list });
    }


    const removeComponent = (index) => {
        setFormData((prevFormObject) => {
            const newArr = [...prevFormObject.medications];
            newArr.splice(index, 1);
            return { ...prevFormObject, medications: newArr };
        });
        if (addMedicationsComponentCount < 3) {
            setShowRemove(false);
        }
        setAddMedicationsComponentCount(prevCount => prevCount - 1);
    };

    const handleSuggestionClick = (suggestion, index) => {

        const foundProduct = aiBupaMedicines.find(
            (item) => item.productId === suggestion.productId
        );

        const list = [...formData.medications];
        list[index]['productId'] = suggestion.productId;
        list[index]['productName'] = suggestion.productName;
        list[index]['sfdaCode'] = suggestion.sfdaCode;

        if (foundProduct) {
            list[index]['quantity'] = foundProduct.quantity;
            list[index]['source'] = 'aibupa';
            list[index]['recommendationId'] = foundProduct.recommendationId;
        }
        setFormData({ ...formData, medications: list });
    };

    console.log(formData);

    return (
        <>

            <div className='col-md-12'>
                <div className='card card-task-appoint'>
                    <div className='card-body'>
                        <div className='card-text'></div>
                        <form id="medicationForm" onSubmit={handleSubmit}>
                            <div className='row'>
                                <div className='col-md-6 mb-3'>
                                    <div className="row">
                                        <div className='col-md-6 mb-1'>
                                            <label className="form-label">Membership</label>
                                            <h5 className='name-label-field' name="membership">{formData['membership']}</h5>
                                        </div>
                                        <div className='col-md-6 mb-1'>
                                            <label className="form-label">Name</label>
                                            <h5 className='name-label-field' name="name">{formData['name']}</h5>
                                        </div>
                                        <div className='col-md-6 mb-3 mt-4'>
                                            <label className="form-label">Mobile Number
                                                <span className='text-danger'>*</span></label>
                                            <input type="text" name="mobileNumber" className='form-control control-input-ui' value={formData['mobileNumber']} onChange={handleChange} />
                                        </div>
                                        <div className='col-md-6 mb-3 mt-4'>
                                            <label className="form-label"> Partner Clinic
                                                <span className='text-danger'>*</span></label>
                                            <select className="form-select select-input-ui" name="partnerClinic" id="partnerClinic" value={formData['partnerClinic']} onChange={handleChange} >
                                                <option value="">-- Select Partner Clinic --</option>
                                                {partnerList.map(option => (
                                                    <option key={option.id} value={option.id}>{option.partnerName}</option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label">Nationality
                                                <span className='text-danger'>*</span>
                                            </label>
                                            <select className="form-select select-input-ui" name="nationality" id="nationality" value={formData['nationality']} onChange={handleChange} >
                                                <option value="">-- Select Nationality --</option>
                                                <option value="Saudi Arabian">Saudi Arabian</option>
                                                <option value="Non Saudi Arabian">Non Saudi Arabian</option>
                                            </select>
                                        </div>

                                        <div className='col-md-3 mb-3'>
                                            <label className="form-label">District</label>
                                            <input type="text" name="district" className='form-control control-input-ui' value={formData['district']} onChange={handleChange} />
                                        </div>

                                        <div className='col-md-3 mb-3'>
                                            <label className="form-label"> Deductible</label>
                                            <input type="text" name="deductible" className='form-control control-input-ui' value={formData['deductible']} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md mb-3 '>
                                    <div className="row">

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label"> Delivery Type
                                                <span className='text-danger'>*</span></label>
                                            <select className="form-select select-input-ui" name="deliveryRefill" id="deliveryRefill" value={formData['deliveryRefill']} onChange={handleChange} >
                                                <option value="">-- Select Delivery Type --</option>
                                                <option value="delivery">Delivery</option>
                                                <option value="pickup">Pickup</option>
                                            </select>
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label"> Order Type
                                                <span className='text-danger'>*</span></label>
                                            <select className="form-select select-input-ui" name="orderType" id="orderType" value={formData['orderType']} onChange={handleChange} >
                                                <option value="">-- Select Order Type --</option>
                                                <option value="1">Refill</option>
                                                <option value="2">New Prescription</option>
                                            </select>
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label">City
                                                <span className='text-danger'>*</span>
                                            </label>

                                            <Select
                                                value={cityList.find(option => option.label === formData.city) || null}
                                                onChange={handleChangeCity}
                                                options={cityList}
                                                isSearchable={true}
                                                placeholder="Select City"
                                                className="form-control select-input-ui select-input-ui-select"
                                            />
                                        </div>

                                        <div className='col-md-6 mb-3'>
                                            <label className="form-label">Pharmacy</label>
                                            <select className="form-select select-input-ui" name="pharmacy" id="pharmacy" value={formData['pharmacy']} onChange={handleChange} >
                                                <option value="">-- Select Pharmacy --</option>
                                                {pharmacyList?.map(option => (
                                                    <option key={option.id} value={option.id}>{option.pharmacyName}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className='col-md-12 mb-3'>
                                            <label className="form-label">Remarks</label>
                                            <input type="text" name="remarks" className='form-control control-input-ui' value={formData['remarks']} onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-12 mb-0'>
                                    <h5 className='name-label-field' style={{height:'auto', marginBottom:'0'}}> Medications</h5>

                                    <div className='col-12'>
                                        <div className="table-responsive">
                                            <table className="table table-borderless mb-0">
                                                <thead>
                                                    <tr>
                                                        <td className='ps-0 pb-1'>Product <span className='text-danger'>*</span></td>
                                                        <td className='ps-0 pb-1'>Quantity <span className='text-danger'>*</span></td>
                                                        <td className='ps-0 pb-1'>Frequency <span className='text-danger'>*</span></td>
                                                        <td className='ps-0 pb-1'>Duration <span className='text-danger'>*</span></td>
                                                        <td className='ps-0 pb-1'>Supply From <span className='text-danger'>*</span></td>
                                                        <td className='ps-0 pb-1'>Supply To <span className='text-danger'>*</span></td>
                                                        <td className='ps-0 pb-1'>Comments</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {[...Array(addMedicationsComponentCount)].map((_, index) => (
                                                        <MedicationsList c={index} key={index} showRemoveButton={showRemove} handleFieldChange={handleFieldChange} data={formData.medications[index]} frequencyData={frequencyList} removeComponent={removeComponent} listType="medications" handleSuggestionClick={handleSuggestionClick} />
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-12 text-center mb-4'>
                                    <button type="button" className="btn btn-primary addNewRow-btn" onClick={() => addComponent()}><i className="bi bi-plus"></i> Add </button>
                                </div>
                                <div className='col-md-12 text-center'>
                                    <div className={`${error != "" ? "errorDiv" : "hide"}`}>{error}</div>
                                    <div className={`${message != "" ? "messageDiv" : "hide"}`}>{message}</div>
                                    <Button variant="primary" type="submit" className="btn btn-primary save-btn" disabled={disabledButton}>Save Medication Request</Button>
                                </div>
                            </div>

                        </form>
                    </div >
                </div >
            </div >
        </>
    )
}

export default MedicationFormsMetaDoc;